import { createContext, useContext, useState } from 'react';
import { translations, defaultLang } from './translations';

const LangCtx = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(defaultLang);

  function switchLang(l) {
    localStorage.setItem('lang', l);
    setLang(l);
  }

  const t = (key) => translations[lang]?.[key] ?? translations.uz[key] ?? key;

  return (
    <LangCtx.Provider value={{ lang, switchLang, t }}>
      {children}
    </LangCtx.Provider>
  );
}

export const useLang = () => useContext(LangCtx);
